import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-ctrl-segment-filter",
  templateUrl: "./ctrl-segment-filter.component.html",
  styleUrls: ["./ctrl-segment-filter.component.css"],
})
export class CtrlSegmentFilterComponent implements OnChanges {
  @Input() survey: any;
  @Input() item: any;
  @Output() itemChanged = new EventEmitter();

  constructor() {}

  ngOnChanges(): void {}

  public onChangeFilter() {
    this.itemChanged.emit({ item: this.item });
  }
}
